import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import { getVisibleSensorAnimation } from "../assets/js/utils";

function HorizontalBroomSweeper({
  text,
  centralImage,
  borderImage,
  thinBorderImage,
}) {
  return (
    <div className="horizontal-broom-sweeper">
      <img
        src={borderImage}
        alt=""
        className="horizontal-broom-sweeper__border-image"
      />

      <VisibilitySensor partialVisibility>
        {({ isVisible }) => (
          <div className="horizontal-broom-sweeper__content">
            <div style={{ position: "relative" }}>
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  backgroundColor: "white",
                  zIndex: 1,
                  ...getVisibleSensorAnimation(
                    isVisible,
                    "width-increase-2-reverse 1s forwards"
                  ),
                }}
              ></div>
              <img
                src={centralImage}
                alt=""
                className="horizontal-broom-sweeper__central-image"
                style={{ visibility: isVisible ? "visible" : "hidden" }}
              />
            </div>
            <div style={{ position: "relative" }}>
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  backgroundColor: "white",
                  zIndex: 1,
                  ...getVisibleSensorAnimation(
                    isVisible,
                    "width-increase-2-reverse 1s 0.3s forwards"
                  ),
                }}
              ></div>
              <p className="horizontal-broom-sweeper__text">{text}</p>
            </div>
          </div>
        )}
      </VisibilitySensor>

      <img
        src={thinBorderImage}
        alt=""
        className="horizontal-broom-sweeper__border-thin-image"
      />
    </div>
  );
}

export default HorizontalBroomSweeper;
